import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CareLabelReferenceService extends BaseReferenceService {
  constructor() {
    super('CareLabelReference');
  }
}
